import React from 'react';
// import { isSearchBetaTester } from 'configs/featureTestConfig';
import ContentWithNavigationSidebar from '../legacy/layouts/ContentWithNavigationSidebar';
// import PatientDirectory from '../legacy/pages/PatientDirectory';
import { AUTHORIZATION_TYPES } from '../legacy/constants';
import PatientFile from '../legacy/pages/PatientFile';
import AddNewPatient from '../legacy/pages/AddNewPatient';
import PatientReport from '../legacy/pages/PatientReport';
import PatientEkgRecording from '../legacy/pages/PatientEkgRecording';
import PagePatientSearch from '../views/pages/PatientSearch';
import ROUTE_PATHS from './routePaths';
import UserProfileProvider from '../auth/contexts/UserProfileContext';
import history from '../legacy/containers/History';

const Routes = [
  {
    redirect: true,
    exact: true,
    from: ROUTE_PATHS.SEARCH,
    to: ROUTE_PATHS.PATIENTS_SEARCH_HOME,
  },

  // {
  //   redirect: true,
  //   exact: true,
  //   from: ROUTE_PATHS.PATIENTS,
  //   to: ROUTE_PATHS.PATIENTS_DIRECTORY,
  // },

  {
    exact: true,
    path: ROUTE_PATHS.PATIENTS,
    component: () => {
      // if (isSearchBetaTester()) {
      history.replace(ROUTE_PATHS.SEARCH);
      // } else {
      //   history.replace(ROUTES.PATIENTS_DIRECTORY);
      // }
      return null; // noop for React
    },
  },

  {
    exact: true,
    authenticatedRoute: true,
    path: `${ROUTE_PATHS.PATIENTS_SEARCH_HOME}/:searchType?`,
    component: props => (
      <UserProfileProvider>
        <PagePatientSearch {...props} />
      </UserProfileProvider>
    ),
  },

  {
    authenticatedRoute: true,
    path: ROUTE_PATHS.PATIENTS_ADD_NEW_PATIENT,
    component: props => (
      <ContentWithNavigationSidebar>
        <AddNewPatient {...props} />
      </ContentWithNavigationSidebar>
    ),
  },

  // {
  //   authenticatedRoute: true,
  //   path: ROUTE_PATHS.PATIENTS_DIRECTORY,
  //   component: props => (
  //     <ContentWithNavigationSidebar>
  //       <PatientDirectory {...props} />
  //     </ContentWithNavigationSidebar>
  //   ),
  // },

  {
    exact: true,
    authenticatedRoute: true,
    path: `${ROUTE_PATHS.PATIENTS_PATIENT_FILE}/:patientId`,
    component: props => {
      const { authorizationType } = props;
      if (authorizationType === AUTHORIZATION_TYPES.EPIC) {
        return <PatientFile {...props} />;
      }
      return (
        <ContentWithNavigationSidebar>
          <PatientFile {...props} />
        </ContentWithNavigationSidebar>
      );
    },
  },

  {
    exact: true,
    authenticatedRoute: true,
    path: `${ROUTE_PATHS.PATIENTS_PATIENT_FILE}/:patientId/reports/:reportId`,
    component: props => {
      const { authorizationType } = props;
      if (authorizationType === AUTHORIZATION_TYPES.EPIC) {
        return <PatientReport {...props} />;
      }

      return (
        <ContentWithNavigationSidebar>
          <PatientReport {...props} />
        </ContentWithNavigationSidebar>
      );
    },
  },

  {
    exact: true,
    authenticatedRoute: true,
    path: `${ROUTE_PATHS.PATIENTS_PATIENT_FILE}/:patientId/recordings/ekg/:recordingId`,
    component: props => {
      const { authorizationType } = props;
      if (authorizationType === AUTHORIZATION_TYPES.EPIC) {
        return <PatientEkgRecording {...props} />;
      }

      return (
        <ContentWithNavigationSidebar>
          <PatientEkgRecording {...props} />
        </ContentWithNavigationSidebar>
      );
    },
  },

  {
    exact: true,
    authenticatedRoute: true,
    path: `${ROUTE_PATHS.PATIENTS_PATIENT_FILE}/:patientId/recordings/ekg/:recordingId/:idtf_connection_id`,
    component: props => {
      const { authorizationType } = props;
      if (authorizationType === AUTHORIZATION_TYPES.EPIC) {
        return <PatientEkgRecording {...props} />;
      }

      return (
        <ContentWithNavigationSidebar>
          <PatientEkgRecording {...props} />
        </ContentWithNavigationSidebar>
      );
    },
  },
];

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/patientRoutes.jsx